import React, { useEffect, useState } from "react"
import { CustomButton, SectionHeader } from "../GlobalComponents/CommonComponents"
import CustomAccordion from "../GlobalComponents/CustomAccordion"
import { FormField } from "../GlobalComponents/Fields"
import "./index.css"
// import Textarea from './TextArea';
import UserRegistrationModal from "./UserRegistrationModal"
import { getUsersByRole } from "../../services/userServices"
import { Box } from "@mui/material"
import { getFullName } from "../../utils/Helpers"

const OptometristDetailsSection = (props) => {
  const {
    formData,
    handleChange,
    options,
    activeModal,
    setActiveModal,
    onCloseModal,
  } = props.data
  let modalData = {}
  if (activeModal === "OptometristModal") {
    modalData = {
      // ...modalData,
      onClose: onCloseModal,
      onSubmit: onSubmit,

      title: "Add New Optometrist",

      show: true,
      formData: {
        role: "Optometrist",
        disabledRole: true,
      },
    }
  }

  useEffect(() => {
    getUsers()
  }, [])

  const [opData, setOPData] = useState([])
  const [isLoading, setIsLoading] = useState(false)
  const [selectedOP, setSelectedOP] = useState(null)

  useEffect(() => {
    if (selectedOP && formData.optometrist !== selectedOP) {
      handleChange({ target: { name: "optometrist", value: selectedOP } })
    }
  }, [selectedOP])

  function handleOPChange(e) {
    console.log("handleGPChange", e.target.value)
    const { name, value } = e.target
    setSelectedOP(e.target.value)
    handleChange(e)
  }


  async function getUsers(id = "") {
    try {
      const opResult = await getUsersByRole({ role: "Optometrist" })
      console.log("onnasdfsadf opResult--23", opResult)
      setIsLoading(false)

      if (opResult?.userDetails?.length) {
        const newOPData = opResult?.userDetails?.map((each) => {
          if (each?._id === formData?.optometrist) {
            console.log("onnasdfsadf OP", id, each)
            setSelectedOP(each)

            handleChange({ target: { name: "optometrist", value: each } })
            // const { name, value } = e.target;
          }
          let label = getFullName(each)

          return { ...each, label, value: each }
        })

        setOPData(newOPData)
      } else {
        setOPData([])
      }
    } catch (error) {
      setOPData([])
    }

    setIsLoading(false)
  }

  function onSubmit(data) {
    console.log("onnasdfsadf", data)
    const id = data?.result?.userDetails?._id
    getUsers(id)

    onCloseModal()
  }

  return (
    <Box>
      <SectionHeader title="Optometrist Details" />
      <Box className="patient-form-fields-container">
        {/* <CustomAccordion title="Optometrist Details"> */}
        <FormField
          deattach={true}
          labelClassName="patient-form-label"
          type="dropdown"
          label="Optometrist"
          placeholder="Optometrist"
          options={opData}
          name="optometrist"
          value={selectedOP}
          // value={formData.optometrist}
          onChange={handleOPChange}
        />

        <CustomButton
          text="Add new optometrist"
          onClick={() => {
            setActiveModal("OptometristModal")
          }}
          style={{ margin: "0px" }}
        />

        {modalData.show && <UserRegistrationModal {...modalData} />}
        {/* </CustomAccordion> */}
      </Box>
    </Box>
  )
}

export default OptometristDetailsSection
